<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-row v-if="sellContract && mdl && issuanceData">
        <a-col :span="24" v-if="sellContract">
          <a-divider orientation="left">
            开具信用证关联信息
          </a-divider>
        </a-col>
        <a-col :span="12" v-if="sellContract">
          <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ sellContract.project }}
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="sellContract">
          <a-form-item label="货物" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ sellContract.product_name }}
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="sellContract">
          <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ sellContract.number }}
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-divider orientation="left">
            信用证付款信息
          </a-divider>
        </a-col>
        <a-col :span="24">
          <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
            {{ issuanceData['business_no'] }}
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="mdl && mdl['issuing_bank']">
          <a-form-item label="开证银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <span>{{ mdl['issuing_bank'] }}</span>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="代开银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['debtor_bank'] }}
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="sellContract">
          <a-form-item label="受益人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <span>{{ sellContract['client'] }}</span>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="开证日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['issue_date'] }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="开证金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['lc_amount'] }} {{ $Dictionaries.currency[issuanceData['lc_amount_currency']] }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="溢短装" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['more_less_clause'] }} %
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="保证金存入日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['margin_deposit_date'] }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="保证金金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['margin_amount'] }} {{ $Dictionaries.currency[issuanceData['margin_amount_currency']] }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="保证金到期日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['margin_maturity_date'] }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="保证金利率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['margin_interest_rate'] }} %
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="到期可用" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            <a-tag color="blue">{{ issuanceData['is_available_at_expiry'] ? '是' : '否' }}</a-tag>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="信用证种类" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ $Dictionaries.trade_lc_types[issuanceData['lc_type']] }}
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="信用证期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
            {{ issuanceData['lc_tenor'] }} 天
          </a-form-item>
        </a-col>
      </a-row>
      <a-form :form="form" class="table-page-search-wrapper">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              信用证承兑信息
            </a-divider>
          </a-col>
          <a-row>
            <a-col :span="24">
              <a-form-item label="业务号" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="承兑日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['acceptance_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="承兑日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="承兑金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number style="width: 50%" :precision="4" v-decorator="['acceptance_amount', {lc_issuance_attachment_deleterules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
                <a-select
                  style="width: 30%"
                  allow-clear
                  v-decorator="[
                    'acceptance_amount_currency',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择币种"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="信用证到期日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['lc_expiry_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="信用证到期日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                到期还款
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="还款日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['repayment_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="还款日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="还款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number style="width: 50%" :precision="4" v-decorator="['repayment_amount', {lc_issuance_attachment_deleterules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
                <a-select
                  style="width: 30%"
                  allow-clear
                  v-decorator="[
                    'repayment_amount_currency',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择币种"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="本位币金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['lcy_amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="本位币金额"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="购汇汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['fx_purchase_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="购汇汇率"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                福费廷
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="福费廷日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['forfaiting_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="福费廷日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="福费廷费率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['forfaiting_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="福费廷费率"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="福费廷主体" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['forfaiting_provider', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="福费廷主体"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="福费廷银行" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input v-decorator="['forfaiting_bank', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="福费廷银行"/>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                押汇
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="押汇日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['negotiation_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="押汇日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="押汇金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number style="width: 50%" :precision="4" v-decorator="['negotiation_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
                <a-select
                  style="width: 30%"
                  allow-clear
                  v-decorator="[
                    'negotiation_amount_currency',
                    {
                      rules: [
                        { required: true, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择币种"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="押汇利率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['negotiation_interest_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="押汇利率"/> %
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="押汇到期日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['negotiation_maturity_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="押汇到期日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="押汇利息扣款方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-select
                  style="width: 50%"
                  allow-clear
                  v-decorator="[
                    'interest_deduction_method',
                    {
                      rules: [
                        { required: false, message: '请选择' },
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in lcInterestDeductionMethod">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="本位币金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['negotiation_lcy_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="本位币金额"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="购汇汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" style="width: 50%" v-decorator="['negotiation_fx_purchase_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="购汇汇率"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="到期还款" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-switch @change="negotiationFacilityMaturityRepaymentChange" checked-children="是" un-checked-children="否" v-model="negotiationFacilityMaturityRepayment"/>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="negotiationFacilityMaturityRepayment">
              <a-divider orientation="left">
                押汇-到期还款
              </a-divider>
            </a-col>
            <a-col :span="12" v-if="negotiationFacilityMaturityRepayment">
              <a-form-item label="到期还款日" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-date-picker
                  v-decorator="['negotiation_repayment_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                  format="YYYY-MM-DD"
                  placeholder="到期还款日"
                  value-format="yyyy-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="negotiationFacilityMaturityRepayment">
              <a-form-item label="还款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <a-input-number :precision="4" v-decorator="['negotiation_repayment_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="金额"/>
                <a-select
                  style="width: 50%"
                  allow-clear
                  v-decorator="[
                    'negotiation_repayment_amount_currency',
                    {
                      rules: [
                        { required: false, message: '请选择' }
                      ],
                    },
                  ]"
                  placeholder="选择币种"
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                附件信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="合同附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="20" v-if="otherData.attachment.length > 0">
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-col>
          </a-row>
          <a-col :span="24" style="padding-top: 5px">
            <a-row>
              <a-col span="4" :offset="8">
                <a-button type="primary" html-type="submit" @click="handleSubmit" :loading="submitting">提交</a-button>
              </a-col>
              <a-col span="12">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAttachmentCancel"
        @ok="handleAttachmentOk"
        :visible="attachmentVisible"
        v-if="attachmentVisible"
        :loading="false"
      />
    </a-spin>
  </a-card>
</template>

<script>
import moment from 'moment'
import {
  lc_acceptance_create, lc_acceptance_list, lc_acceptance_update,
  lc_application_list,
  lc_issuance_list
} from '@/api/trade_credit_letter'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { sell_contract_list } from '@/api/trade_sell_contract'
import pick from 'lodash.pick'

const fields = ['id', 'business_no', 'acceptance_date', 'acceptance_amount', 'acceptance_amount_currency', 'lc_expiry_date', 'repayment_date', 'repayment_amount',
  'repayment_amount_currency', 'lcy_amount', 'fx_purchase_rate', 'forfaiting_date', 'forfaiting_rate', 'forfaiting_provider', 'forfaiting_bank', 'negotiation_date',
'negotiation_amount', 'negotiation_amount_currency', 'negotiation_interest_rate', 'negotiation_maturity_date', 'interest_deduction_method', 'negotiation_lcy_amount',
'negotiation_fx_purchase_rate', 'negotiation_repayment_date', 'negotiation_repayment_amount', 'negotiation_repayment_amount_currency']

export default {
  components: {
    AttachmentCreateForm
  },
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      sellContract: undefined,
      issuanceData: undefined,
      acceptanceData: undefined,
      mdl: undefined,
      id: 0,
      currency: this.$Dictionaries.currency,
      tradePaymentRelatedContract: this.$Dictionaries.trade_related_contract,
      contractTypes: this.$Dictionaries.contractTypes,
      bankServicesTypeList: this.$Dictionaries.bank_services_types,
      letterCreditTypeList: this.$Dictionaries.letter_credit_types,
      marginSourceList: this.$Dictionaries.margin_resources,
      lcInterestDeductionMethod: this.$Dictionaries.trade_interest_deduction_method,
      data: undefined,
      negotiationFacilityMaturityRepayment: false,
      attachmentVisible: false,
      loading: false,
      submitting: false,
      bankFetching: false,
      advisingBankFetching: false,
      otherData: {
        attachment: []
      },
      bankList: [],
      issuingBankId: undefined,
      accordingContract: true,
      selectedLetterCreditType: 0,
      attachmentColumns: [
        {
          title: '名称',
          width: 150,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted () {
    this.loadSellContractInfo()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    loadSellContractInfo () {
      this.loading = true
      lc_application_list({ id: this.$route.query.lc_application_id })
        .then(res => {
          this.mdl = res.data.entries[0] || []
        }).finally(() => {
        if (this.mdl !== undefined && this.mdl['sell_contract_id'] !== undefined) {
          // 获取购销合同
          sell_contract_list({ id: this.mdl['sell_contract_id'] }).then(res => {
            if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
              this.sellContract = res.data.entries[0]
            }
          })
          // 获取开具信用证
          lc_issuance_list({ id: this.$route.params.lc_issue_id }).then(res => {
            if (res !== undefined && res.code === 1000 && res.data !== undefined && res.data.entries !== undefined && res.data.entries.length > 0) {
              this.issuanceData = res.data.entries[0]
            } else {
              this.loading = false
            }
          }).finally(() => {
            if (this.issuanceData) {
              this.issuanceData.lc_type = '' + this.issuanceData.lc_type
              // 获取开具信用证承兑
              lc_acceptance_list({ lc_issuance_id: this.issuanceData['id'] }).then(res => {
                if (res.code === 1000 && res.data.entries.length > 0) {
                  console.log('开具信用证承兑', res.data.entries[0])
                  this.acceptanceData = res.data.entries[0]
                  if (this.acceptanceData !== undefined) {
                    this.negotiationFacilityMaturityRepayment = this.acceptanceData.negotiation_repayment_date !== '1970-01-01'
                    if (this.acceptanceData.attachment !== undefined && this.acceptanceData.attachment.length > 0) {
                      const current_date = new Date()
                      this.otherData.attachment = this.acceptanceData.attachment.map(item => {
                        item.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + Math.random() * 10000
                        return item
                      })
                    }
                    this.loadEditInfo(this.acceptanceData)
                  }
                }
              }).finally(() => {
                this.loading = false
              })
            } else {
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          this.loading = true
          this.submitting = true
          if (this.issuanceData) {
            values['lc_issuance_id'] = this.issuanceData.id
          }
          if (this.otherData.attachment) {
            values['attachment'] = this.otherData.attachment.map(item => {
              item.key = undefined
              return item
            })
          }
          if (!this.negotiationFacilityMaturityRepayment) {
            values['negotiation_repayment_date'] = '1970-01-01'
          }
          if (this.acceptanceData === undefined) {
            lc_acceptance_create(values)
              .then((res) => {
                this.handleGoBack()
                console.log(res, '创建成功')
              }).finally(() => {
              this.loading = false
              this.submitting = false
            })
          } else {
            lc_acceptance_update(values, this.acceptanceData.id)
              .then((res) => {
                this.handleGoBack()
                console.log(res, '修改成功')
              }).finally(() => {
              this.loading = false
              this.submitting = false
            })
          }
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    negotiationFacilityMaturityRepaymentChange (value) {
      this.negotiationFacilityMaturityRepayment = value
      this.form.setFieldsValue({ negotiation_repayment_date: '1970-01-01' })
    },
    handleAddAttachment () {
      this.attachmentVisible = true
    },
    handleAttachmentCancel () {
      this.attachmentVisible = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachmentOk () {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          // 显示
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.attachmentVisible = false
          form.resetFields()
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        formData.interest_deduction_method = '' + formData.interest_deduction_method
        formData.bank_services_type = '' + formData.bank_services_type
        formData.letter_credit_type = '' + formData.letter_credit_type
        formData.margin_source = '' + formData.margin_source
        console.log('formData', formData)
        this.id = formData.id
        formData.type = String(formData.type)
        form.setFieldsValue(formData)
      }).finally(() => {
        if (data.debtor_bank_id) {
          this.backLoadList({ id: data.debtor_bank_id }, 1)
        }
      })
    }
  }
}
</script>
